import { FieldValue } from "backend/datainput";
import { ICardElementWithChildren } from "backend/model/model";
import * as types from "client-api-workflow/types";
import ValueInputForm from "design/components/forms/ValueInputForm";
import { t } from "i18next";
import React from "react";

const KPIInputForm = (props: {
  kpi: ICardElementWithChildren;
  childElements: ICardElementWithChildren[];
  comments?: types.WFComment[];
  attachments?: types.FileValue[];
  onSubmit?: (values: FieldValue[]) => void;
  isReadOnly?: boolean;
}) => {
  const { kpi, childElements, comments, attachments } = props;

  const isNumeric = (s: string) => !isNaN(+s) && isFinite(+s) && !/e/i.test(s);

  return (
    <ValueInputForm
      buttons={[
        {
          tag: "submit",
          style: "submit",
          text: t("workflowinput.form.Submit").toString(),
          onClick: props.onSubmit,
        },
      ]}
      key={kpi?.workflowInstance?.wfInstanceId}
      element={kpi!}
      childElements={childElements}
      onIntermediateChange={(values) => {}}
      fields={[
        {
          title: t("workflowinput.form.ACT").toString(),
          series: "ACT",
          initialValue: props.kpi.ACT_valuewithoutsymbol,
          element: kpi,
          inputType: "string",
          isDisabled: props.isReadOnly,
          unitSeries: "ACT_unit",
          validate: (state) => {
            if (!state.field.value) {
              return {
                success: false,
                errorMessages: [
                  t("workflowinput.form.errors.Value can not be empty"),
                ],
              };
            }

            if (!isNumeric(state.field.value)) {
              return {
                success: false,
                errorMessages: [
                  t("workflowinput.form.errors.Value must be number"),
                ],
              };
            }

            return {
              success: true,
              errorMessages: [],
            };
          },
        },
        {
          title: t("workflowinput.form.TAR").toString(),
          series: "TAR",
          initialValue: props.kpi.TAR_valuewithoutsymbol,
          element: kpi,
          inputType: "string",
          isDisabled: true,
          unitSeries: "TAR_unit",
        },
        {
          title: t("workflowinput.form.Attachments"),
          element: kpi,
          inputType: "attachments",
          initialFiles: attachments,
          isDisabled: props.isReadOnly,
          validate: (state) => {
            if (!state.field.files || state.field.files?.length < 1) {
              return {
                success: false,
                errorMessages: [
                  t("workflowinput.form.errors.Attachments can not be empty"),
                ],
              };
            } else
              return {
                success: true,
                errorMessages: [],
              };
          },
        },
        {
          title: t("workflowinput.form.Actions and Recommendations"),
          element: kpi,
          inputType: "comment",
          comments: comments,
          isDisabled: props.isReadOnly,
          initialValue: comments && comments[0] ? comments[0].description : "",
          validate: (state) => {
            if (!state.field.value || state.field.value?.length < 1) {
              return {
                success: false,
                errorMessages: [
                  t(
                    "workflowinput.form.errors.Actions and Recommendations can not be empty"
                  ),
                ],
              };
            } else
              return {
                success: true,
                errorMessages: [],
              };
          },
        },
      ]}
    />
  );
};

export default KPIInputForm;
